export const VOID_CITY_EXTERIOR_DOOR_SPAWNS = Object.freeze({
  arena: { x: 1296, y: 1066 },
  merchant: { x: 80, y: 1130 },
  decksmith: { x: 592, y: 1130 },
  gameHall: { x: 912, y: 618 },
  questHall: { x: 688, y: 1642 },
});

export const VOID_CITY_EXTERIOR_RETURN_SPAWNS_BY_DOOR_ID = Object.freeze({
  "door-40-31": VOID_CITY_EXTERIOR_DOOR_SPAWNS.arena,
  "door-2-33": VOID_CITY_EXTERIOR_DOOR_SPAWNS.merchant,
  "door-18-33": VOID_CITY_EXTERIOR_DOOR_SPAWNS.decksmith,
  "door-28-17": VOID_CITY_EXTERIOR_DOOR_SPAWNS.gameHall,
  "door-21-49": VOID_CITY_EXTERIOR_DOOR_SPAWNS.questHall,
});

export const getVoidCityExteriorDoorSpawnByBuilding = (building = "") =>
  VOID_CITY_EXTERIOR_DOOR_SPAWNS[building] || null;

export const getVoidCityExteriorReturnSpawnByDoorId = (doorId = "") =>
  VOID_CITY_EXTERIOR_RETURN_SPAWNS_BY_DOOR_ID[doorId] || null;
